'use client';

import { useEffect, useState } from 'react';

const SEEN_KEY = 'rushmid:howto:seen';

/**
 * First-run gate for the intro slides: open on the first lobby visit on this
 * device, closed forever once dismissed (Skip, backdrop or the final CTA).
 * localStorage-only — deliberately not a profile flag, a re-show after a
 * device switch is fine.
 */
export const useFirstRun = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(SEEN_KEY)) setOpen(true);
    } catch { /* storage unavailable (private mode) — just skip the intro */ }
  }, []);

  const dismiss = () => {
    setOpen(false);
    try { localStorage.setItem(SEEN_KEY, '1'); } catch { /* same */ }
  };

  return { open, dismiss };
};
